module.exports = __webpack_public_path__ + "img/error-500-xl.b30b4144.jpg";